<router-outlet></router-outlet>
@if (loading()) {
  <ui-loading [showLogo]="true"></ui-loading>
}
<tw-toast-viewport></tw-toast-viewport>
